'use strict';

module.exports = function () {
    $(document).on('change', '.points-toggle-control-js', function () {
        const isPointsToggled =  !!$(this).prop('checked');
        let url = $(this).parents('.loyalty-points-toggle-section').data('url');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: {
                isPointsToggled
            },
            success: function (data) {
                $('.original-price-js').toggleClass('d-none', data.isPointsToggled);
                $('.loyalty-points-js').toggleClass('d-none', !data.isPointsToggled);
                $('.points-msg-js').toggleClass('d-none', !data.isPointsToggled);
                $('.points-toggle-control-js').prop('checked', data.isPointsToggled);
                if($('.points-deficiency-js').length && (!$('.points-deficiency-js').html().length > 0 || $('.points-deficiency-js').html() === 'null')) {
                    $('.points-deficiency-message-js').addClass('d-none');
                }

                if($('.earn-formatted-points-js').length && (!$('.earn-formatted-points-js').html().length > 0 || $('.earn-formatted-points-js').html() === 'null')) {
                    $('.cart-earn-display-message-js').addClass('d-none');
                }

                // Trigger custom event to update cart
                $('body').trigger('pointsToggle:updated', { isPointsToggled: data.isPointsToggled });
            }
        });
    });
};